var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.294,
    cy: 25.3253,
    r: 25.1337,
    transform: "rotate(180 25.294 25.3253)",
    fill: "#003A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6619 26.3437L22.0409 34.534C21.4925 35.0553 20.6033 35.0553 20.0552 34.534C19.507 34.0132 19.507 33.1685 20.0552 32.6477L27.6835 25.4006L20.0554 18.1537C19.5072 17.6326 19.5072 16.788 20.0554 16.2672C20.6036 15.7462 21.4927 15.7462 22.0411 16.2672L30.6621 24.4576C30.9362 24.7182 31.0731 25.0593 31.0731 25.4005C31.0731 25.742 30.936 26.0833 30.6619 26.3437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.d8fe351541c03f6f8bb254e0984b5962.svg";
export { ForwardRef as ReactComponent };